import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	resultLabel: {
		id: 'search-commit-result.label',
		defaultMessage: 'Commit',
		description: 'Search commit label',
	},
});
